// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ICodeExchangeRequestDto
 */
export interface ICodeExchangeRequestDto {
    /**
     * 
     * @type {string}
     * @memberof ICodeExchangeRequestDto
     */
    code?: string;
    /**
     * 
     * @type {string}
     * @memberof ICodeExchangeRequestDto
     */
    redirect_url?: string;
}

/**
 * Check if a given object implements the ICodeExchangeRequestDto interface.
 */
export function instanceOfICodeExchangeRequestDto(value: object): value is ICodeExchangeRequestDto {
    return true;
}

export function ICodeExchangeRequestDtoFromJSON(json: any): ICodeExchangeRequestDto {
    return ICodeExchangeRequestDtoFromJSONTyped(json, false);
}

export function ICodeExchangeRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ICodeExchangeRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'redirect_url': json['redirect_url'] == null ? undefined : json['redirect_url'],
    };
}

export function ICodeExchangeRequestDtoToJSON(json: any): ICodeExchangeRequestDto {
    return ICodeExchangeRequestDtoToJSONTyped(json, false);
}

export function ICodeExchangeRequestDtoToJSONTyped(value?: ICodeExchangeRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'redirect_url': value['redirect_url'],
    };
}

